import { render } from "./Macros.vue?vue&type=template&id=036457dc"
import script from "./Macros.vue?vue&type=script&lang=js"
export * from "./Macros.vue?vue&type=script&lang=js"

import "./Macros.vue?vue&type=style&index=0&id=036457dc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__